import axios from 'axios';

import {Api} from '@/shared/model/api.model';
import DataService from "@/core/base/service/data.service";
import {ApiPage} from "@/entities/api/interface/api-page";

export default class ApiService extends DataService<Api> {

    protected baseApiUrl: string = "api/apis";

    public test(id: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios
                .get(`${this.baseApiUrl}/test/${id}`)
                .then(res => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public reauthenticate(id: number): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public sync(id: number, withMeasurings: boolean): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios
                .put(`${this.baseApiUrl}/sync/${id}`, {
                    withMeasurings,
                })
                .then(res => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public pages(id: number): Promise<ApiPage[]> {
        return new Promise<ApiPage[]>((resolve, reject) => {
            axios
                .get(`${this.baseApiUrl}/availablePages/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public createState(type: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}`, {type})
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
